import { HelpersService } from './../../../services/tools/helpers.service';
import { Component, OnInit, Input } from '@angular/core';
import { InversionistasService } from '../../../services/inversionistas.service';
import {InversionistasGruposService} from "../../../services/inversionistas-grupos.service";
import {ValidatorService} from "../../../services/tools/validator.service";
import { ObrasService } from '../../../services/obras.service';
declare var jquery;
declare var $;


@Component({
  selector: 'app-catalogo-obras-inversionistas',
  templateUrl: './catalogo-obras-inversionistas.component.html',
  styleUrls: ['./catalogo-obras-inversionistas.component.scss']
})
export class CatalogoObrasInversionistasComponent implements OnInit {

  @Input() public inversionistas: any[] = [];
  @Input() public gruposInversionistas: any[]
  @Input() public errors: any[] = [];
  public now;
  public participacionTotal = 0;
  public inversionistasList: any[];
  public inversionistaSelected;
  public participacionSelected = 0;
  public inversionSelected = 0;
  public inversionistaSelectorGroups: any[] = [];
  constructor(  private inversionistasService: InversionistasService,
                private validatorService: ValidatorService,
                private helperService: HelpersService,
                private obrasService: ObrasService) {
    this.resetInversionistaSelected();
    this.getInversionistasList();
    this.now = new Date().toISOString().slice(0, 10);
   }

  ngOnInit() {
    $('#fechaInicio').daterangepicker({
      singleDatePicker: true,
      showDropdowns: true,
      maxDate: this.now,
      minDate: '2012-10-1',
      locale: {
        format: 'YYYY-MM-DD'
      }
    });
    this.errors['inversionistas'] = undefined;
  }

  public setParticipacion(quantity, inversionista) {
    if (inversionista === undefined) {
      this.participacionSelected = quantity;
      this.calcularParticipacionTotal(quantity);
    } else {
      this.setParticipacionInversionistaList(quantity, inversionista);
      this.calcularParticipacionTotal();
    }
  }



  public isValidParticipacionTotal() {
    if (this.participacionTotal > 100) {
      this.errors['inversionistas'] = 'Se excedio el porcentaje permitido de 100%';
      return false;
    }

    if (this.existsInList()) {
      return false;
    }
    const group_error = this.groupsValidator();
    if (this.validatorService.required(group_error)) {
      this.errors['inversionistas'] = group_error;
      return false;
    }

    if (this.inversionistaSelected === 'Inversionista o Grupo') {
      return false;
    }

    this.errors['inversionistas'] = undefined;
    return true;
  }
  /* se valida que el total de participacion de los integrantes de un grupo no sea mayor al seleccionado para le grupo */
  public groupsValidator() {

    let error = '';
    for (const group of this.gruposInversionistas) {
      if (group.inversionistas_elementos) {
        let groupParticipacionTotal: number = 0;
        for (const inversionista of group.inversionistas_elementos) {
          groupParticipacionTotal += parseFloat(inversionista.participacion) || 0;
        }
        if (group.participacion < groupParticipacionTotal) {
          error = 'El grupo ' + group.inversionistas_grupos.nombre + ' ha excedido la participacion de sus integrantes';
        }
        if (group.participacion > groupParticipacionTotal) {
          error = 'La suma del porcentaje de inversionistas debe coincidir al total asignado al grupo ' + group.inversionistas_grupos.nombre;
        }
      }
    }
    return error;
  }

  public setParticipacionInversionistaList(quantity, inversionista) {
    this.inversionistas.forEach(function(item) {
      if (item === inversionista) {
        item.participacion = quantity;
      }
    });
  }

  public calcularParticipacionTotal(plus = null) {
    this.participacionTotal = 0;
    for (const item of this.inversionistas) {
      this.participacionTotal = this.participacionTotal + parseFloat(item.participacion);
    }

    for (const item of this.gruposInversionistas) {
      this.participacionTotal = this.participacionTotal + parseFloat(item.participacion);
    }

    if (plus) {
      this.participacionTotal = this.participacionTotal + parseFloat(plus);
    }
    this.isValidParticipacionTotal();
  }

  public resetInversionistaSelected() {
    this.inversionistaSelected = undefined;
    this.participacionSelected = 0;
    this.inversionSelected = 0;
    this.participacionTotal = 0;
    this.errors['inversionistas'] = '';
  }

  writePermission() {
    return this.obrasService.writePermission();
  }

  public getInversionistasList() {
     this.inversionistasService.getInversionistasList('/obras')
      .subscribe(response => {
        const respuesta = response.json();
        this.inversionistaSelectorGroups.push({
          'text': 'Inversionistas',
          'children': respuesta.content.inversionistas,
          'key': 'idInversionistas',
          'label': 'nombre'
        });
        this.inversionistaSelectorGroups.push({
          'text': 'Grupo de Inversionistas',
          'children': respuesta.content.inversionistas_Grupos,
          'key': 'idInversionistas_Grupos',
          'label': 'nombre'
        });
      }, error => {
        // resolviendo errores 403 y 500
        this.helperService.httpGlobalError(error);
      });
  }

  public addInversionista() {

    console.log('inversionistaSelected...', this.inversionistaSelected);

    if (this.inversionistaSelected && this.isValidParticipacionTotal()) {

      this.inversionistaSelected.participacion = this.participacionSelected;
      this.inversionistaSelected.inversionInicial = this.inversionSelected;
      if (this.validatorService.required(this.inversionistaSelected.idInversionistas)) {
        this.inversionistaSelected.inversionistas = {};
        this.inversionistaSelected.inversionistas.nombre = this.inversionistaSelected.nombre;
        this.inversionistas.push(this.inversionistaSelected);
      }

      if (this.validatorService.required(this.inversionistaSelected.idInversionistas_Grupos)) {
        this.inversionistaSelected.inversionistas_grupos = {};
        this.inversionistaSelected.inversionistas_grupos.nombre = this.inversionistaSelected.nombre;
        const inversionistaCloned = JSON.parse(JSON.stringify( this.inversionistaSelected ));
        this.gruposInversionistas.push(inversionistaCloned);
      }
      this.resetInversionistaSelected();
    }
  }

  public existsInList() {
    let exists = false;
    if (!this.inversionistaSelected) {
      return false;
    }
    if (this.validatorService.required(this.inversionistaSelected.idInversionistas)) {
      for (const item of this.inversionistas) {
        if (item.idInversionistas == this.inversionistaSelected.idInversionistas) {
          this.errors['inversionistas'] = 'Este Inversionista ya se encuentra registrado en la Obra';
          exists = true;
        }
      }
    }

    if (this.validatorService.required(this.inversionistaSelected.idInversionistas_Grupos)) {
      for (const item of this.gruposInversionistas) {
        if (item.idInversionistas_Grupos == this.inversionistaSelected.idInversionistas_Grupos) {
          this.errors['inversionistas'] = 'Este Grupo ya se encuentra registrado en la Obra';
          exists = true;
        }
      }
    }

    return exists;
  }

  public deleteInversionista(index) {
    this.inversionistas.splice(index, 1);
  }

  public deleteGrupoInversionista(index) {
    this.gruposInversionistas.splice(index, 1);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/catalogo-obras/catalogo-obras-inversionistas/catalogo-obras-inversionistas.component.ts